module.exports = __webpack_public_path__ + "static/media/61.5527db5b.png";